import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_account_profile_details",
  "aria-expanded": "true",
  "aria-controls": "kt_account_profile_details"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Profile Details")
  ])
], -1)
const _hoisted_3 = {
  id: "kt_account_profile_details",
  class: "collapse show"
}
const _hoisted_4 = { class: "card-body border-top p-9" }
const _hoisted_5 = { class: "row mb-6" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Full Name", -1)
const _hoisted_7 = { class: "col-lg-8" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-lg-6 fv-row" }
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "col-lg-6 fv-row" }
const _hoisted_13 = { class: "fv-plugins-message-container" }
const _hoisted_14 = { class: "fv-help-block" }
const _hoisted_15 = { class: "row mb-6" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Job Title", -1)
const _hoisted_17 = { class: "col-lg-8 fv-row" }
const _hoisted_18 = { class: "fv-plugins-message-container" }
const _hoisted_19 = { class: "fv-help-block" }
const _hoisted_20 = { class: "row mb-6" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Introduction", -1)
const _hoisted_22 = { class: "col-lg-8 fv-row" }
const _hoisted_23 = { class: "fv-plugins-message-container" }
const _hoisted_24 = { class: "fv-help-block" }
const _hoisted_25 = { class: "row mb-6" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Contact Phone"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-1 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Phone number must be active"
  })
], -1)
const _hoisted_27 = { class: "col-lg-8 fv-row" }
const _hoisted_28 = { class: "fv-plugins-message-container" }
const _hoisted_29 = { class: "fv-help-block" }
const _hoisted_30 = { class: "row mb-6" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "LinkedIn", -1)
const _hoisted_32 = { class: "col-lg-8 fv-row" }
const _hoisted_33 = { class: "fv-plugins-message-container" }
const _hoisted_34 = { class: "fv-help-block" }
const _hoisted_35 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("button", {
  type: "reset",
  class: "btn btn-white btn-active-light-primary me-2"
}, " Discard ", -1)
const _hoisted_37 = ["data-kt-indicator"]
const _hoisted_38 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_39 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" Please wait... ")
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_42 = [
  _hoisted_40,
  _hoisted_41
]
const _hoisted_43 = { class: "card mb-5 mb-xl-10" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_account_signin_method"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-boldest m-0" }, "Change Password")
  ])
], -1)
const _hoisted_45 = {
  id: "kt_account_signin_method",
  class: "collapse show"
}
const _hoisted_46 = { class: "card-body border-top p-9" }
const _hoisted_47 = { class: "mb-8" }
const _hoisted_48 = { class: "row mb-6" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Old Password", -1)
const _hoisted_50 = { class: "col-lg-4 fv-row" }
const _hoisted_51 = { class: "fv-plugins-message-container" }
const _hoisted_52 = { class: "fv-help-block" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-4" }, null, -1)
const _hoisted_54 = { class: "mb-8" }
const _hoisted_55 = { class: "row mb-6" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "New Password", -1)
const _hoisted_57 = { class: "col-lg-4 fv-row" }
const _hoisted_58 = { class: "fv-plugins-message-container" }
const _hoisted_59 = { class: "fv-help-block" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-4" }, null, -1)
const _hoisted_61 = { class: "mb-8" }
const _hoisted_62 = { class: "row mb-6" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Confirm New Password", -1)
const _hoisted_64 = { class: "col-lg-4 fv-row" }
const _hoisted_65 = { class: "fv-plugins-message-container" }
const _hoisted_66 = { class: "fv-help-block" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-4" }, null, -1)
const _hoisted_68 = ["data-kt-indicator"]
const _hoisted_69 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_70 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_71 = /*#__PURE__*/_createTextVNode(" Please wait... ")
const _hoisted_72 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_73 = [
  _hoisted_71,
  _hoisted_72
]
const _hoisted_74 = { class: "card mb-5 mb-xl-10" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_account_deactivate",
  "aria-expanded": "true",
  "aria-controls": "kt_account_deactivate"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-boldest m-0" }, "Deactivate Account")
  ])
], -1)
const _hoisted_76 = {
  id: "kt_account_deactivate",
  class: "collapse show"
}
const _hoisted_77 = { class: "card-body border-top p-9" }
const _hoisted_78 = { class: "notice d-flex bg-light-warning rounded border-warning border border-dashed mb-9 p-6" }
const _hoisted_79 = { class: "svg-icon svg-icon-2tx svg-icon-warning me-4" }
const _hoisted_80 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-stack flex-grow-1\"><div class=\"fw-bold\"><h4 class=\"text-gray-800 fw-bolder\"> You Are Deactivating Your Account </h4><div class=\"fs-6 text-gray-600\"> For extra security, this requires you to confirm your email or phone number when you reset yousignr password. <br><a class=\"fw-bolder\" href=\"#\">Learn more</a></div></div></div>", 1)
const _hoisted_81 = /*#__PURE__*/_createElementVNode("div", { class: "form-check form-check-solid fv-row" }, [
  /*#__PURE__*/_createElementVNode("input", {
    name: "deactivate",
    class: "form-check-input",
    type: "checkbox",
    value: "",
    id: "deactivate"
  }),
  /*#__PURE__*/_createElementVNode("label", {
    class: "form-check-label fw-bold ps-2 fs-6",
    for: "deactivate"
  }, "Confirm Account Deactivation")
], -1)
const _hoisted_82 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_83 = {
  id: "kt_account_deactivate_account_submit",
  ref: "submitButton5",
  type: "submit",
  class: "btn btn-danger fw-bold"
}
const _hoisted_84 = /*#__PURE__*/_createElementVNode("span", {
  "data-bs-toggle": "modal",
  "data-bs-target": `#kt_modal_deactivate`,
  class: "indicator-label"
}, " Deactivate Account ", -1)
const _hoisted_85 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_86 = [
  _hoisted_84,
  _hoisted_85
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_DeactivateAccountModal = _resolveComponent("DeactivateAccountModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Form, {
          id: "kt_account_profile_details_form",
          class: "form",
          novalidate: "novalidate",
          onSubmit: _cache[8] || (_cache[8] = ($event: any) => (_ctx.saveChanges1())),
          "validation-schema": _ctx.profileDetailsValidator
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "firstName",
                        class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
                        placeholder: "First name",
                        modelValue: _ctx.profileDetails.firstName,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.profileDetails.firstName) = $event))
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_ErrorMessage, { name: "firstName" })
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "lastName",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: "Last name",
                        modelValue: _ctx.profileDetails.lastName,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.profileDetails.lastName) = $event))
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_ErrorMessage, { name: "lastName" })
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "jobTitle",
                    class: "form-control form-control-lg form-control-solid",
                    placeholder: "Job Title",
                    modelValue: _ctx.profileDetails.jobTitle,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.profileDetails.jobTitle) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_ErrorMessage, { name: "jobTitle" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "introduction",
                    class: "form-control form-control-lg form-control-solid",
                    placeholder: "Introduction",
                    modelValue: _ctx.profileDetails.introduction,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.profileDetails.introduction) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createVNode(_component_ErrorMessage, { name: "introduction" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _createElementVNode("div", _hoisted_27, [
                  _createVNode(_component_Field, {
                    onInput: _cache[4] || (_cache[4] = ($event: any) => {_ctx.formatTelephone($event);}),
                    onKeypress: _cache[5] || (_cache[5] = ($event: any) => (_ctx.limitInput($event))),
                    type: "tel",
                    name: "telephone",
                    class: "form-control form-control-lg form-control-solid",
                    placeholder: "Phone number",
                    modelValue: _ctx.profileDetails.telephone,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.profileDetails.telephone) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createVNode(_component_ErrorMessage, { name: "telephone" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _createElementVNode("div", _hoisted_32, [
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "linkedInProfileUrl",
                    class: "form-control form-control-lg form-control-solid",
                    placeholder: "LinkedIn",
                    modelValue: _ctx.profileDetails.linkedInProfileUrl,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.profileDetails.linkedInProfileUrl) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createVNode(_component_ErrorMessage, { name: "linkedInProfileUrl" })
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              _createElementVNode("button", {
                "data-kt-indicator": _ctx.loading ? 'on' : null,
                type: "submit",
                id: "kt_account_profile_details_submit",
                ref: "submitButton1",
                class: "btn btn-primary"
              }, [
                (!_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_38, " Save Changes "))
                  : _createCommentVNode("", true),
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_39, _hoisted_42))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_37)
            ])
          ]),
          _: 1
        }, 8, ["validation-schema"])
      ])
    ]),
    _createElementVNode("div", _hoisted_43, [
      _hoisted_44,
      _createVNode(_component_Form, {
        class: "form",
        novalidate: "novalidate",
        onSubmit: _ctx.changePasswordSubmit,
        "validation-schema": _ctx.changePassword
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, [
                  _hoisted_49,
                  _createElementVNode("div", _hoisted_50, [
                    _createVNode(_component_Field, {
                      ref: "oldPasswordRef",
                      type: "password",
                      name: "oldPassword",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: "Old Password"
                    }, null, 512),
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("div", _hoisted_52, [
                        _createVNode(_component_ErrorMessage, { name: "oldPassword" })
                      ])
                    ])
                  ]),
                  _hoisted_53
                ])
              ]),
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("div", _hoisted_55, [
                  _hoisted_56,
                  _createElementVNode("div", _hoisted_57, [
                    _createVNode(_component_Field, {
                      ref: "newPasswordRef",
                      type: "password",
                      name: "password",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: "New Password"
                    }, null, 512),
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("div", _hoisted_59, [
                        _createVNode(_component_ErrorMessage, { name: "password" })
                      ])
                    ])
                  ]),
                  _hoisted_60
                ])
              ]),
              _createElementVNode("div", _hoisted_61, [
                _createElementVNode("div", _hoisted_62, [
                  _hoisted_63,
                  _createElementVNode("div", _hoisted_64, [
                    _createVNode(_component_Field, {
                      ref: "passwordConfirmationRef",
                      type: "password",
                      name: "password_confirmation",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: "Confirm New Password"
                    }, null, 512),
                    _createElementVNode("div", _hoisted_65, [
                      _createElementVNode("div", _hoisted_66, [
                        _createVNode(_component_ErrorMessage, { name: "password_confirmation" })
                      ])
                    ])
                  ]),
                  _hoisted_67
                ])
              ]),
              _createElementVNode("button", {
                "data-kt-indicator": _ctx.loading2 ? 'on' : null,
                type: "submit",
                class: "btn btn-primary"
              }, [
                (!_ctx.loading2)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_69, " Save Changes "))
                  : _createCommentVNode("", true),
                (_ctx.loading2)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_70, _hoisted_73))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_68)
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ]),
    _createElementVNode("div", _hoisted_74, [
      _hoisted_75,
      _createElementVNode("div", _hoisted_76, [
        _createElementVNode("form", {
          id: "kt_account_deactivate_form",
          class: "form",
          onSubmit: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_77, [
            _createElementVNode("div", _hoisted_78, [
              _createElementVNode("span", _hoisted_79, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen044.svg" })
              ]),
              _hoisted_80
            ]),
            _hoisted_81
          ]),
          _createElementVNode("div", _hoisted_82, [
            _createElementVNode("button", _hoisted_83, _hoisted_86, 512)
          ])
        ], 32)
      ])
    ]),
    _createVNode(_component_DeactivateAccountModal)
  ], 64))
}